import { render, staticRenderFns } from "./BlocoAlertaMonitoramentoAgricola.vue?vue&type=template&id=922345da&scoped=true&lang=pug"
import script from "./BlocoAlertaMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./BlocoAlertaMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./BlocoAlertaMonitoramentoAgricola.vue?vue&type=style&index=0&id=922345da&prod&lang=scss"
import style1 from "./BlocoAlertaMonitoramentoAgricola.vue?vue&type=style&index=1&id=922345da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922345da",
  null
  
)

export default component.exports